export type SupportedAppChainId = string | 'fake200101' | 'fake2001';

export const SUPPORTED_NETWORK_IDS: SupportedAppChainId[] =
  process.env.VUE_APP_SUPPORTED_NETWORK_IDS?.split(',') ?? [];
